import { SourceType } from 'types/SourceType'

export const translateSourcetype = (sourceType: SourceType) => {
    const translations: Partial<Record<SourceType, string>> = {
        Cancellation: 'Avbruten',
        Update: 'Uppdatering',
        Stabilisation: 'Stabilisering',
        'New commitments': 'Nya åtaganden',
        Outcome: 'Utfall',
        Publication: 'Offentliggörande',
        PublicationWarrant: 'Ursprung',
        Terms: 'Villkor',
        InformationDocument: 'Informationsdokument',
        Prospectus: 'Prospekt',
        Conversion: 'Konvertering',
        Offset: 'Kvittning',
        Repayment: 'Återbetalning',
    }

    return translations[sourceType] || sourceType
}
